(function (angular) {
    'use strict';

    angular
        .module('app.purchase')
        .controller('app.purchase.termsOfUseModalController', [
            '$scope',
            '$http',
            termsOfUseModalController
        ]);

    function termsOfUseModalController($scope, $http) {
        $scope.tosHtml = '';
        var apiUrl = environment.treatmentApiDirectUrl + 'files/public-documents/terms-of-use.html';

        $http.get(apiUrl)
            .then(function (response) {
                $scope.tosHtml = response.data;
            });
    }

})(angular);
